import { render, staticRenderFns } from "./ScreenIcon.vue?vue&type=template&id=96e1b458&scoped=true"
import script from "./ScreenIcon.vue?vue&type=script&lang=js"
export * from "./ScreenIcon.vue?vue&type=script&lang=js"
import style0 from "./ScreenIcon.vue?vue&type=style&index=0&id=96e1b458&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e1b458",
  null
  
)

export default component.exports